(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["kcs-multicolumn"] && !Shopify.designMode) return;
  try {
    function initializeKcsMulticolumn(root) {
    var components = [];

    if (root.matches && root.matches('[data-kcs-multicolumn]')) {
      components.push(root);
    }

    Array.prototype.forEach.call(root.querySelectorAll('[data-kcs-multicolumn]'), function (component) {
      components.push(component);
    });

    components.forEach(function (component) {
      if (component.dataset.kcsMulticolumnInitialized === 'true') return;

      var track = component.querySelector('[data-kcs-slider-track]');
      var previousButton = component.querySelector('[data-kcs-slider-previous]');
      var nextButton = component.querySelector('[data-kcs-slider-next]');
      var currentOutput = component.querySelector('[data-kcs-slider-current]');
      var totalOutput = component.querySelector('[data-kcs-slider-total]');

      if (!track || !previousButton || !nextButton || !currentOutput || !totalOutput) return;

      component.dataset.kcsMulticolumnInitialized = 'true';

      function getItems() {
        return Array.prototype.slice.call(track.querySelectorAll('.kcs-multicolumn__item'));
      }

      function getCurrentIndex(items) {
        if (!items.length) return 0;

        var trackLeft = track.getBoundingClientRect().left;
        var closestIndex = 0;
        var closestDistance = Infinity;

        items.forEach(function (item, index) {
          var distance = Math.abs(item.getBoundingClientRect().left - trackLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        return closestIndex;
      }

      function updateControls() {
        var items = getItems();
        var currentIndex = getCurrentIndex(items);

        totalOutput.textContent = String(Math.max(items.length, 1));
        currentOutput.textContent = String(items.length ? currentIndex + 1 : 1);
        previousButton.disabled = currentIndex <= 0;
        nextButton.disabled = !items.length || currentIndex >= items.length - 1;
      }

      function move(direction) {
        var items = getItems();
        if (!items.length) return;

        var currentIndex = getCurrentIndex(items);
        var targetIndex = Math.max(0, Math.min(items.length - 1, currentIndex + direction));
        var target = items[targetIndex];

        track.scrollTo({
          left: target.offsetLeft,
          behavior: 'smooth'
        });
      }

      previousButton.addEventListener('click', function () {
        move(-1);
      });

      nextButton.addEventListener('click', function () {
        move(1);
      });

      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          updateControls();
          ticking = false;
        });
      }, { passive: true });

      window.addEventListener('resize', updateControls);
      updateControls();
    });
  }

  function initializeKcsMulticolumnPage() {
    initializeKcsMulticolumn(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeKcsMulticolumnPage);
  } else {
    initializeKcsMulticolumnPage();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeKcsMulticolumn(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var item = event.target.closest('.kcs-multicolumn__item');
    if (!item) return;

    var component = item.closest('[data-kcs-multicolumn]');
    var track = component ? component.querySelector('[data-kcs-slider-track]') : null;

    if (track && window.matchMedia('(max-width: 749px)').matches) {
      track.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
